<template>
  <div style="display: none">{{ content }}</div>
</template>

<script>
export default {
  data () {
    return {
      content: 'Hello foot!'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/default/footer.vue